<template>
  <div class="satelliteDataApply">
    <Header/>
    <div class="content">
      <div class="current-loc">
        <span>{{ $t('satellite.CurrentPosition') }}：</span>
        <span class="n1">{{ $t('header.ServicesResource') }}</span>
        <span class="el-icon-arrow-right n-right"></span>
        <span class="n2">{{ $t('header.DataDistributionAndTransfer') }}</span>
      </div>
      <div class="query">
        <el-button size="mini" @click="centerDialogVisible=true">{{ $t('DataSubmission.Add') }}</el-button>
        <el-button size="mini" @click="deleteThis">{{ $t('DataSubmission.Delete') }}</el-button>
      </div>
      <div class="data-table">
        <el-table
            :empty-text="$t('Intelligent.NoData')"
            :header-cell-style="{'background-color':'rgba(2, 105, 255, 1)','color':'white','border':'none'}"
            :data="tableData"
            height="500"
            ref="multipleTable"
            :cell-style="satellite_apply_cell_style_bd"
            :style="satellite_apply_cell_style_bd">
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column
              prop="distributeTime"
              :label="$t('algorithm2.DistributionTime')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="satelliteName"
              :label="$t('services.SatelliteType')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="productName"
              :label="$t('satellite.ProductTypes')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="date"
              width="310"
              :label="$t('satellite.TimeRange')"
              align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.startTime }}~{{ scope.row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="dataSize"
              :label="$t('product.Datavolume')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="userName"
              :label="$t('algorithm2.name')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="organizational"
              :label="$t('algorithm2.Institution')"
              align="center">
          </el-table-column>
          <el-table-column
              prop="phone"
              :label="$t('DataSubmission.telephone')">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation" style="margin-top:12px">
        <el-pagination
            background
            @current-change="currentChange"
            :page-size="pageOption.limit"
            layout="total,prev, pager, next,jumper"
            :total="total">
        </el-pagination>
      </div>
      <el-dialog
          :title="$t('header.DataDistributionAndTransfer')"
          :visible.sync="centerDialogVisible"
          width="40%"
          center>
        <el-form :model="ruleForm" :rules="isEnglish?rules_en:rules" ref="ruleForm" label-width="auto"
                 class="demo-ruleForm">
          <el-form-item :label="$t('satellite.ClassificationOfTheSatellite')" prop="satelliteType">
            <el-select @change="changeQuery" v-model="ruleForm.satelliteType" :placeholder="$t('services.Pleaseselect')"
                       size="medium">
              <el-option :label="i.dicItemName" :value="i.pkid" v-for="i in satelliteOption" :key="i.index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('satellite.ProductTypes')" prop="productId">
            <el-select @change="changeQueryProduct" v-model="ruleForm.productId"
                       :placeholder="$t('services.Pleaseselect')" size="medium">
              <el-option :label="i.productName" :value="i.productId" v-for="i in productOption"
                         :key="i.index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="date" :label="$t('satellite.TimeRange')">
            <el-date-picker
                v-model="ruleForm.date"
                size="medium"
                type="daterange"
                value-format='yyyy-MM-dd HH:mm:ss'
                range-separator="-"
                :start-placeholder="$t('satellite.Start')"
                :end-placeholder="$t('satellite.End')">
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('algorithm2.Amountofdatadistributed')" prop="dataSize">
            <el-input v-model="ruleForm.dataSize" size="medium">
              <span slot="suffix">GB</span>
            </el-input>
          </el-form-item>

          <el-form-item :label="$t('algorithm2.name')" prop="userName">
            <el-input v-model="ruleForm.userName" size="medium"></el-input>
          </el-form-item>
          <el-form-item :label="$t('DataSubmission.telephone')" prop="phone">
            <el-input v-model="ruleForm.phone" size="medium"></el-input>
          </el-form-item>
          <el-form-item :label="$t('algorithm2.Institution')" prop="organizational">
            <el-input v-model="ruleForm.organizational" size="medium"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="centerDialogVisible = false">{{
                    $t('DataSubmission.Cancel')
                  }}</el-button>
                <el-button size="mini" type="primary" @click="submit">{{ $t('DataSubmission.confirm') }}</el-button>
            </span>
      </el-dialog>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"

import {mapGetters} from "vuex";
import {
  getCopyRcord,
  getBySatelliteType,
  addCopyRcored,
  deleteCopyRcored
} from "@/api/satellite"
import {
  getLikeByDicCodelist
} from "@/api/product"

export default {
  name: 'satelliteDataApply',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      total: 0,
      centerDialogVisible: false,
      ruleForm: {
        satelliteType: '',
        productId: '',
        satelliteName: '',
        productName: '',
        date: '',
        dataSize: '',
        userName: '',
        phone: '',
        organizational: ''
      },
      satelliteOption: [],
      productOption: [],
      rules: {
        satelliteType: [
          {required: true, message: '请选择卫星分类', trigger: 'change'}
        ],
        productId: [
          {required: true, message: '请选择产品类型', trigger: 'change'}
        ],
        date: [
          {required: true, message: '请选择时间范围', trigger: 'change'}
        ],
        dataSize: [
          {required: true, message: '请输入分发数据量', trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'}
        ],
        organizational: [
          {required: true, message: '请输入工作单位', trigger: 'blur'}
        ]
      },
      rules_en: {
        satelliteType: [
          {required: true, message: 'Please select satellite classification', trigger: 'change'}
        ],
        productId: [
          {required: true, message: 'Please select a product type', trigger: 'change'}
        ],
        date: [
          {required: true, message: 'Please select a time range', trigger: 'change'}
        ],
        dataSize: [
          {required: true, message: 'Please enter the amount of distributed data', trigger: 'blur'}
        ],
        userName: [
          {required: true, message: 'Please enter your name', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: 'Please enter your contact number', trigger: 'blur'}
        ],
        organizational: [
          {required: true, message: 'Please enter your work unit', trigger: 'blur'}
        ]
      },
      pageOption: {
        page: 1,
        limit: 10
      },
      tableData: [],
      isEnglish: false
    }
  },
  watch: {
    showTable(val) {
      if (!val) {
        this.$nextTick(() => {
          this.initDrawMap()
        })
      } else {
        this.reset()
      }
    }
  },
  computed: {
    ...mapGetters(['themeStatis', 'header_cell_style_bd', 'satellite_apply_cell_style_bd']),
  },
  methods: {
    changeQuery(val) {
      const result = this.satelliteOption.find(item => item.pkid === val)
      if (result) {
        this.getProduct(result.dicItemCode)
        this.ruleForm.satelliteName = result.dicItemName
      }
    },
    changeQueryProduct(val) {
      const result = this.productOption.find(item => item.productId === val)
      if (result) {
        this.ruleForm.productName = result.productName
      }
    },
    async getProduct(val) {
      let res = await getBySatelliteType({
        satelliteType: val
      })
      this.productOption = res.data
      this.ruleForm.productId = ''
    },
    async getSate() {
      let res = await getLikeByDicCodelist({
        dicCode: "SATELLITE_TYPE"
      })
      this.satelliteOption = res.data.SATELLITE_TYPE
    },
    async addOne() {
      let params = this.ruleForm
      params.startTime = this.ruleForm.date[0]
      params.endTime = this.ruleForm.date[1]
      let res = await addCopyRcored(params)
      console.log(res);
      if (res.code === '000000') {
        this.$message.success('新增成功！')
        this.$refs.ruleForm.resetFields()
        this.centerDialogVisible = false
        this.getList()
      }
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.addOne()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async deleteThis() {
      let that = this
      let params
      let all = that.$refs.multipleTable.selection.map(item => item.pkid)
      params = {
        pkIds: all
      }
      let res = await deleteCopyRcored(params)
      if (res.code === '000000') {
        that.$message.success('删除成功')
      }
      that.getList()
    },
    currentChange(val) {
      this.pageOption.page = val
      this.getList()
    },
    async getList() {
      let that = this
      let res = await getCopyRcord(that.pageOption)
      that.tableData = res.data.list
      that.total = parseInt(res.data.totalCount)
    },
    reset() {
      this.value1 = null
    },
    cellSyle() {
      return {'background-color': 'rgba(10, 12, 29, 1)', 'color': 'white', 'border': 'none'}
    },
  },
  created() {
    this.getList()
    this.getSate()
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  }
}
</script>

<style lang="scss" scoped>
.current-loc {
  height: 21px;
  display: flex;
  font-size: 16px;
  align-items: center;
  margin-top: 30px;

  .n1 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    @include co_white_to_black();
  }

  .n-right {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    @include co_white_to_black();
    margin: 0 3px;
  }

  .n2 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    //color: rgba(2, 105, 255, 1);
    cursor: pointer;
  }
}

.satelliteDataApply {
  width: 100%;
  @include satellite_apply_bg();

  .content {
    min-height: 659px;
    width: 1551px;
    margin: 0 auto;

    .query {
      display: flex;
      align-items: center;
      font-size: 15px;
      margin: 33px 0 16px 0;
    }

    .data-table {
      margin: 20px 0;
    }

    .pagenation {
      display: flex;
      justify-content: center;
      padding-right: 0;
      margin: 40px 0 20px 0;

      &-left {
        display: flex;
        align-items: center;
      }
    }

    .new-apply {
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      @include co_white_to_black();

      .new-t {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #0269FF;
        margin: 38px 0 18px 0;

        .clolr-kuai {
          margin-right: 6px;
          width: 5px;
          height: 17px;
          background: #0269FF;
        }
      }

      .xuxian {
        width: 100%;
        height: 1px;
        @include satellite_apply_xuxian_bg();
        background-size: 28px 1px;
        background-repeat: repeat-x;
      }

      .zhongjian {
        display: flex;
        justify-content: space-between;

        .left, .zhong, .right {
          width: 380px;

          .form-site {
            margin-top: 23px;
          }
        }
      }

      .map-title {
        margin-top: 25px;
      }

      .map-box {
        width: 100%;
        height: 484px;
        position: relative;

        .basemap {
          width: 100%;
          height: 100%;
          margin-top: 6px;
          @include satellite_apply_input_bg();
          border-radius: 2px;
        }

        .map-tool {
          width: 27px;
          background: #FFFFFF;
          border-radius: 4px;
          position: absolute;
          padding: 3px 0;
          top: 12px;
          left: 12px;
          z-index: 500;

          display: flex;
          align-items: center;
          flex-direction: column;

          span {
            color: rgba(2, 105, 255, 1);
            margin: 3px 0;
          }
        }
      }

      .btn-box {
        height: 36px;
        display: flex;
        justify-content: flex-end;
        margin: 19px 0;

        .btn {
          width: 100px;
          height: 34px;
          border-radius: 5px;
          border: 1px solid #0269FF;
          cursor: pointer;
        }

        .cancel-btn {
          margin-right: 28px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #0269FF;
        }

        .cancel-btn:hover {
          background-color: rgba(2, 105, 255, 0.2);
        }

        .sure-btn {
          background: #0269FF;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
        }

        .sure-btn:hover {
          background-color: rgba(2, 105, 255, .8);
        }
      }

    }
  }

  ::v-deep .btn-next {
    margin-right: 0;
  }

  ::v-deep .el-pagination {
    padding-right: 0;
  }
}

/deep/ .el-table-column--selection {
  .cell {
    padding: 0 10px;
  }
}

/deep/ .el-table::before {
  background-color: transparent;
}

/deep/ .input-site {
  width: 100%;
  background: #2D3359;
  border: none;
  margin-top: 5px;

  input {
    background: #2D3359;
    border: none;
  }

  textarea {
    background: #2D3359;
    border: none;
    height: 101px;
  }
}

/deep/ .input-site2 {
  width: 100%;
  background: white;
  margin-top: 5px;

  input {
    background: white;
  }

  textarea {
    background: white;
    height: 101px;
  }
}

/deep/ .warning-row {
  background: rgba(16, 31, 67, 1) !important;
}
</style>